module.exports = __webpack_public_path__ + "img/1.f84f8940.png";